
const config = {
  rowSelection: false,
  fieldControl: false,
  searchMode: "group",
  columns: [
    {
      title: "目标类型",
      dataIndex: "categoryDisplay",
      width: 150,
      ellipsis: true,
    },
    {
      title: "门店",
      dataIndex: "companyName",
      width: 150,
      ellipsis: true,
    },
    {
      title: "年月",
      dataIndex: "yearMonth",
      width: 120,
      ellipsis: true,
    },
    {
      title: "产品分类",
      dataIndex: "productionTypeName",
      width: 120,
      ellipsis: true,
    },
    {
      title: "战略目标（万）",
      dataIndex: "performanceObjectivesAmount",
      width: 200,
      ellipsis: {
        showTitle: true,
        overlayStyle: {minWidth: '50px'}
      }
    },
    {
      title: "理想目标（万）",
      dataIndex: "pkTargetAmount",
      width: 200,
      ellipsis: {
        showTitle: true,
        overlayStyle: {minWidth: '50px'}
      }
    },
    {
      title: "操作",
      render: "actionTool",
      width: 220,
      "fixed": "right"
    }
  ],
  search: [
    {
      name: "category",
      label: "类型",
      itemType: "select",
      data: "category",
      key: "priKey",
      labelKey: "name",
    },
    {
      name: "suitCompanys",
      label: "适用门店",
      itemType: "tree",
      key: "orgId",
      labelKey: "companyName",
      childrenKey: "child",
      data: "company",
      treeCheckable: true,
      showCheckedStrategy: "SHOW_PARENT"
    },
    {
      name: "yearMonth",
      label: "年月",
      itemType: "date",
      picker: "month"
    },
    {
      name: "productionType",
      label: "产品分类",
      itemType: "select",
      data: "productType",
      key: "priKey",
      labelKey: "name"
    }
  ],
  footer: [
    {
      label: "新增",
      type: "primary",
      events: [
        "onClick:onAdd"
      ]
    },
  ]
}

export default config;